import React from "react";

const PhoneIcon = ({
  size = 24,
  color = "#222222",
  className = "",
  ...props
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M15.0159 10.0249C15.7354 10.3378 16.1421 11.1198 15.9544 11.9019L15.2974 14.7487C15.141 15.4995 14.4841 16 13.702 16C6.13148 16 0 9.86852 0 2.29801C0 1.51593 0.500529 0.85899 1.25132 0.702575L4.09808 0.0456305C4.88016 -0.142068 5.66224 0.264612 5.97507 0.984123L7.28896 4.08115C7.60179 4.73809 7.38281 5.52017 6.81971 5.98941L5.78737 6.83406C6.60073 8.2418 7.7582 9.39927 9.16594 10.2126L10.0106 9.18029C10.4798 8.61719 11.2619 8.39821 11.9501 8.71104L15.0159 10.0249ZM14.4841 11.5578C14.5153 11.4952 14.4841 11.4327 14.4215 11.4014L11.3558 10.0875C11.2932 10.0562 11.2306 10.0562 11.1993 10.1188L9.94802 11.6517C9.72904 11.9019 9.32236 11.9958 9.00953 11.8393C6.91356 10.807 5.19299 9.08644 4.16065 6.99047C4.00423 6.67764 4.09808 6.30225 4.34835 6.05198L5.88122 4.83194C5.94378 4.76937 5.94378 4.70681 5.9125 4.64424L4.59861 1.5785C4.56733 1.54722 4.53605 1.51594 4.47348 1.51594H4.4422L1.59544 2.17288C1.53287 2.17288 1.4703 2.23545 1.4703 2.29801C1.4703 9.02387 6.97613 14.4984 13.702 14.4984C13.7646 14.4984 13.8271 14.4671 13.8271 14.4046L14.4841 11.5578Z"
        fill={color}
      />
    </svg>
  );
};

export default PhoneIcon;